import { ProtectorApi } from '@core/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganization } from '../useOrganization';
import { setNotificationsQueryData } from './useReadNotifications.utils';
import { UserNotificationDTO } from './userNotifications.models';

function useReadUserNotification() {
  const queryClient = useQueryClient();
  const { organization } = useOrganization();
  return useMutation({
    mutationKey: ['read-user-notification'],
    mutationFn: async (notificationIds: string[]) => {
      await queryClient.cancelQueries({ queryKey: ['user-notifications'] });

      queryClient.setQueryData<{ [key: string]: UserNotificationDTO }>(
        ['user-notifications', { workspace_id: organization?.workspace_id }],
        (oldData) => {
          return setNotificationsQueryData({
            oldData,
            notificationIds,
            status: 'READ',
          });
        }
      );

      const items = notificationIds.map((id) => ({ id, status: 'READ' }));

      const { data } = await ProtectorApi.post<{ items: { id: string; error: string | null }[] }>(
        '/user-notifications/notification/actions/update',
        {
          items,
        }
      );

      const unreadNotifications = data.items.filter((notification) => !!notification.error);

      queryClient.setQueryData<{ [key: string]: UserNotificationDTO }>(
        ['user-notifications', { workspace_id: organization?.workspace_id }],
        (oldData) => {
          return setNotificationsQueryData({
            oldData,
            notificationIds: unreadNotifications.map((n) => n.id),
            status: 'SENT',
          });
        }
      );
    },
  });
}

export { useReadUserNotification };
